import React, { useState, useEffect } from "react";

const About = () => {

  useEffect(() => {
		window.scrollTo({ top: 0, behavior: 'smooth' });
	});

  return (
    <>
      <main className="sa-main-wrap sa-trems-pages-wrap">
            <div className="container">
            <div className="breadcrumpart">
               <ul>
                  <li>
                     <a href="#">Home</a>
                  </li>
                  <li>
                    About Us 
                  </li>
               </ul>
            </div>
         </div>
         <div className="container">
           <section className="sa-trems-content">
            
          <p><strong><span dir="LTR"><strong>About Us</strong></span></strong></p>

<p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>

</section>
           </div>
         </main>
    </>
  );
};

export default About;
